var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Fence"},[_c('swiper',{attrs:{"banners":_vm.banners}}),_c('div',{staticClass:"Fence0"},[_c('breadcrumb',{attrs:{"refer":_vm.refer}}),_c('div',{staticClass:"Fences"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }